<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-ToolboxB`]" width="1em" height="1em" v-bind="$attrs"><defs><linearGradient x1="0" y1="0" x2="1" y2="1" id="svg_c8a2135532__b"><stop offset="0%" stop-color="#D334F7"/><stop offset="100%" stop-color="#7C34F7"/></linearGradient><clipPath id="svg_c8a2135532__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_c8a2135532__a)"><path d="M18,8L30,8L30,6.5C30,5.94772,29.5523,5.5,29,5.5L19,5.5C18.447699999999998,5.5,18,5.94772,18,6.5L18,8ZM33,8L38,8C41.866,8,45,11.13401,45,15L45,23L29.676,23Q29.2454,21.7602,28.2426,20.7574Q26.4853,19,24,19Q21.5147,19,19.7574,20.7574Q18.7546,21.7602,18.323999999999998,23L3,23L3,15C3,11.13401,6.13401,8,10,8L15,8L15,5.5Q15,4.25736,15.8787,3.37868Q16.7574,2.5,18,2.5L30,2.5Q31.2426,2.5,32.121300000000005,3.3786620000000003Q33,4.25734,33,5.5L33,8ZM27,25Q27,23.7574,26.1213,22.8787Q25.2426,22,24,22Q22.7574,22,21.8787,22.8787Q21,23.7574,21,25Q21,26.2426,21.8787,27.1213Q22.7574,28,24,28Q25.2426,28,26.1213,27.1213Q27,26.2426,27,25ZM3,37L3,26L18.075699999999998,26Q18.3646,27.8499,19.7574,29.2426Q21.5147,31,24,31Q26.4853,31,28.2426,29.2426Q29.6354,27.8499,29.9243,26L45,26L45,37C45,40.866,41.866,44,38,44L10,44C6.13401,44,3,40.866,3,37Z" fill-rule="evenodd" :fill="useCurrentColor ? 'currentColor' : 'url(#svg_c8a2135532__b)'"/></g></svg>
</template>
<script>

export default {
  name: 'IconToolboxB',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
